import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import classNames from 'classnames';
import { type MobileMenuTabsProps } from './MobileMenu.types';
import { ChevronDown } from '@/icons';

const MobileMenuTabs: React.FC<MobileMenuTabsProps> = ({
  categories,
  onLinkClick,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  if (!categories) return;

  return (
    <div className="mobile-menu__tabs-wrapper">
      <div className="mobile-menu__tabs-buttons">
        <AnimatePresence initial={false}>
          <motion.div
            className="mobile-menu__tabs-button-bg"
            initial={{ left: '0%' }}
            animate={{ left: activeIndex === 0 ? '0%' : '50%' }}
          ></motion.div>
        </AnimatePresence>

        <ul className="mobile-menu__tabs">
          {categories.map((item, index) => {
            const isActive = index === activeIndex;
            const { title } = item;

            return (
              <li
                key={index}
                className={classNames({
                  'mobile-menu__tabs-item': true,
                  'mobile-menu__tabs-item--active': isActive,
                })}
              >
                <button
                  type="button"
                  className="mobile-menu__tabs-button"
                  onClick={() => {
                    setActiveIndex(index);
                  }}
                >
                  {title}
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      <AnimatePresence initial={false} mode="wait">
        <ul className="mobile-menu__tabs-menu">
          {categories.map((item, index) => {
            const isActive = index === activeIndex;
            const { children } = item;

            return (
              <li
                key={index}
                className={classNames({
                  'mobile-menu__tabs-item': true,
                  'mobile-menu__tabs-item--active': isActive,
                })}
              >
                {isActive && (
                  <motion.div
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -40 }}
                    exit={{ opacity: 0, x: 40 }}
                    transition={{ duration: 0.2 }}
                  >
                    <ul className="mobile-menu__list">
                      {children.map((child, index) => (
                        <li key={index} className="mobile-menu__list-item">
                          {child.children.length > 0 ? (
                            <button
                              type="button"
                              className="mobile-menu__list-button"
                              onClick={(e) => {
                                const active =
                                  document.getElementById('active-panel');
                                if (active) active.id = '';
                                e.currentTarget.id = 'active-panel';
                                onLinkClick(child.id, child.title);
                              }}
                            >
                              {child.title}
                              <ChevronDown
                                className="mobile-menu__list-icon"
                                fill="currentColor"
                                width={12}
                              />
                            </button>
                          ) : (
                            <a
                              href={child.url}
                              className="mobile-menu__list-link"
                              target={child.isNewWindow && '_blank'}
                            >
                              {child.title}
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  </motion.div>
                )}
              </li>
            );
          })}
        </ul>
      </AnimatePresence>
    </div>
  );
};

export default MobileMenuTabs;
